// The two PURE halves of `src/features/workflows/workflowAnalytics.ts`, moved
// because the carved run/event-rule mutations call them to build their
// app-reaction payloads.
//
// History: partial extraction —
// `git log --follow -- src/features/workflows/workflowAnalytics.ts`.
//
// Bodies are byte-identical to the pre-move source. Neither function emits
// anything: `parseRunAnyWorkflowInput` normalises the mutation's variadic input
// and `eventTypesLabel` joins a list, so both are input handling that belongs
// with the hook rather than with the emitter that stayed app-side.
//
// NEITHER WAS DIRECTLY COVERED BEFORE. `workflowAnalytics.ts` has no suite of
// its own; both were exercised only through the hooks suite, which asserted the
// defaults incidentally by asserting the resulting analytics call. The sibling
// `routine-analytics.test.ts` pins them directly, including the defaults a
// caller relies on without naming them (`run_button` / `on_demand`).
import type {
  RunAnyWorkflowInput,
  WorkflowTriggerSource,
  WorkflowTriggerType,
} from '../../contracts/routines-analytics.types';
import type { EventType } from '../../contracts/routines.types';

export function parseRunAnyWorkflowInput(input: RunAnyWorkflowInput): {
  workflowId: string;
  session_id?: string;
  trigger_source: WorkflowTriggerSource;
  trigger_type: WorkflowTriggerType;
  requires_desktop?: boolean;
  preset_id?: string | null;
} {
  if (typeof input === 'string') {
    return {
      workflowId: input,
      trigger_source: 'run_button',
      trigger_type: 'on_demand',
    };
  }
  return {
    workflowId: input.workflowId,
    session_id: input.session_id,
    trigger_source: input.trigger_source ?? 'run_button',
    trigger_type: input.trigger_type ?? 'on_demand',
    requires_desktop: input.requires_desktop,
    preset_id: input.preset_id,
  };
}

export function eventTypesLabel(eventTypes: EventType[]): string | undefined {
  return eventTypes.length > 0 ? eventTypes.join(',') : undefined;
}
